import { useEffect, useState } from "react";
import SendIcon from '@mui/icons-material/Send';
import ClearIcon from '@mui/icons-material/Clear';
import Button from '@mui/material/Button';


import Table from "../table";
import "./request.css";

import axios from 'axios';
const BASE_URL = process.env.REACT_APP_BASE_URL;


const OpenForm = ({ onClose }) => {
  const [subject, setSubjectValue] = useState('');

  return (
    <div className="form-overlay">
      <div className="form-modal">
      <Button className="close_modal" onClick={onClose} variant='contained' endIcon={<ClearIcon/>}></Button>
      <form className="form" onSubmit ={(e)=>{
        var formData = new FormData(e.target);
        var api = {
          "teacher_id":1,
          "requestType":formData.get('subject'),
          "message": formData.get('message'),
          "requestStatus":"pending"
        }

        axios({
          url:`${BASE_URL}/addRequest`,
          method:"POST",
          data:api

        }).then(()=>{
          console.log("success")
        }).catch(()=>{
          console.log("sorry")
        })
      e.preventDefault()
       // onClose()
      }}>

        <div className="form">
          <div className="title">Send your Request</div>
         
          <div className="component">
            <label className="field_lable">Message</label>
            <input name="message" />
          </div>
          <div className="component">
            <label className="field_lable">Subject</label>
            <select onChange={(e) => { setSubjectValue(e.target.value) }} name="subject">
            <option value="Select">Select your request type</option>
              <option value="productOrder">Product Order</option>
              <option value="paymentRequest">Payment Request</option>
              <option value="newAdm">New Admission</option>
            </select>
          </div>
        
          <Button className="submit" type="submit" variant="contained"endIcon={<SendIcon/>}>Send Request</Button>
        </div>
        </form>
      </div>
     
    </div>
  );
};

const Request = () => {
  const [showForm, setShowForm] = useState(false);
  const [loading,setLoading] = useState(false);
  const [data,setData] = useState();
  useEffect(()=>{
    axios.get(`${BASE_URL}/getRequest`,{
      params:{
        teacherId: 4
      }
    }).then(response =>{
      setLoading(false);
      setData(response.data)
    }).catch(error=>{
      console.error(error,'error fetching')
    })

  },[])


  const columns = [
    {
     name: "requestType",
     label: "Subject",
     options: {
      filter: true,
      sort: true,
     }
    },
    {
     name: "message",
     label: "Message",
     options: {
      filter: true,
      sort: false,
     }
    },
    {
     name: "requestStatus",
     label: "Status",
     options: {
      sort: false,
     }
    }
   ];

 

  return (
    <div className="main-component" style={{ paddingLeft: '29px', width: '100%' }}>
      <Button onClick={() => setShowForm(!showForm)}>Send Request</Button>
      
      {showForm && <OpenForm onClose={() => setShowForm(false)} />}
      <div className="table_data">
        <Table data={data} columns={columns} />
      </div>
    </div>
  );
};

export default Request;


